/**
 * @file WallController
 * @description
 * Load into your application like `myApp.controller('WallController', require('WallController.js'))`
 */
module.exports = ["$scope", "DataService", function($scope, DataService) {
    const _controller = this;

    let _totalCount = '0000';
    const _counterLength = _totalCount.length;


    _controller.count = () => {
        _totalCount = $scope.$parent.$parent.detail.campaign.membercount;

        let count = `${_totalCount}`;

        while(count.length < _counterLength) {
            count = `0${count}`;
        }
        if ((count === 'undefined') || (typeof count === 'undefined')) {
            count = '0000';
        }
        return count.split('');
    };

    (function init() {
        _controller.count();
    }());
}];
